module.exports = __webpack_public_path__ + "fonts/deposit-detail-guide-2.213fe9ads.png";